export interface IGetMedicationCountForPatientsRequest {
    cadInterventionNo: number;
    patientIds: string; // separado por vírgulas
}
